import script from "./app_layout.vue?vue&type=script&lang=ts&setup=true&name=AppLayout"
export * from "./app_layout.vue?vue&type=script&lang=ts&setup=true&name=AppLayout"

import "./app_layout.vue?vue&type=style&index=0&id=1efc51bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1efc51bc"]])

export default __exports__